<template>
  <div class="custom-swatches">
    <div class="custom-swatches__container">
      <template
        v-for="(option, index) of options"
        :key="index"
      >
        <input
          :id="`size-${option.value}`"
          class="custom-swatches__radio"

          type="radio"
          name="size"
          :value="option.value"
          :disabled="option.disabled && !notifyBis ? true : null"
          @click="update(option)"
        >
        <label
          class="
            custom-swatches__label
          "
          :class="{
            'custom-swatches__label--active':
              currentVariantId?.toString() === option.value.toString(),
            'custom-swatches__label--disabled':
              option.disabled && !notifyBis ? true : null,
          }"
          :for="`size-${option.value}`"
          v-text="option.title"
        />
      </template>

      <select
        v-show="false"
        :tabindex="tabIndex"
        :name="name ? name : null"
      >
        <option
          v-for="(option, index) of options"
          ref="options"
          :key="index"
          :selected="option.value === value ? true : false"
          :value="option.value"
          v-text="option.title"
        />
      </select>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Custom swatches (custom-swatches)
 * -----------------------------------------------------------------------------
 * Generic swatch inputs.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'CustomSwatches',

  props: {
    options: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    notifyBis: {
      type: Boolean,
      default: false,
      required: true,
    },
    tabIndex: {
      type: String,
      default: '0',
    },
    name: {
      type: String,
      default: '',
    },
    currentVariantId: {
      type: [Number, String],
      default: '',
    },
    value: {
      type: [Number, String],
      default: '',
    },
  },

  emits: {
    update: (payload) => typeof payload === 'object',
    'state-change': (payload) => typeof payload === 'object',
  },

  data() {
    return {
      selected: false,
      state: false,
      height: 0,
    }
  },
  mounted() {
    this.$emit('update', this.currentVariantId)
  },
  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Update select with chosen option.
     * @param {Object} option
     */
    update(option) {
      const found = this.$refs.options.find((opt) => opt.value === option.value.toString())

      if (!found) {
        return
      }

      this.selected = option.title
      if (!option.disabled) {
        this.$emit('update', option.value)
      }

      /**
       * Open BIS modal in case variant in not available
       * and BIS enabled for product.
       */
      if (option.disabled && this.notifyBis) {
        this.openModal()
      }
    },

    /**
     * Open Modal.
     */
    openModal() {
      this.toggleOverlay({
        ignoreDismissed: true,
        namespace: 'backInStock',
      })
    },

    /**
     * Check if swatch is active on load
     * @param {Object}
     * @return {Object}
     */
    checkActive(swatch) {
      const active = swatch.id === this.product.id

      if (active) {
        this.active = swatch
      }

      return active
    },

  },
}
</script>

<style lang="scss">
@import './custom-swatches';
</style>
